import {
  AcceptedFileType,
  ImageDimensions,
  ValidationResult,
} from './ImageUploader.types';

/**
 * Valida el tipo de archivo
 */
export const validateFileType = (
  file: File,
  acceptedFormats: AcceptedFileType[]
): ValidationResult => {
  const fileExtension = `.${file.name.split('.').pop()?.toLowerCase()}` as AcceptedFileType;
  
  if (!acceptedFormats.includes(fileExtension)) {
    return {
      isValid: false,
      error: `Formato no permitido. Solo se aceptan: ${acceptedFormats.join(', ')}`,
    };
  }

  return { isValid: true };
};

/**
 * Valida el tamaño del archivo
 */
export const validateFileSize = (
  file: File,
  maxSizeKB: number
): ValidationResult => {
  const fileSizeKB = file.size / 1024;

  if (fileSizeKB > maxSizeKB) {
    return {
      isValid: false,
      error: `El archivo excede el tamaño máximo de ${maxSizeKB} KB`,
    };
  }

  return { isValid: true };
};

/**
 * Valida las dimensiones de la imagen
 */
export const validateImageDimensions = (
  img: HTMLImageElement,
  dimensions: ImageDimensions
): ValidationResult => {
  if (img.width !== dimensions.width || img.height !== dimensions.height) {
    return {
      isValid: false,
      error: `La imagen debe tener dimensiones de ${dimensions.width}x${dimensions.height}px`,
    };
  }

  return { isValid: true };
};

/**
 * Formatea el texto de información de restricciones
 */
export const formatConstraintsText = (
  acceptedFormats: AcceptedFileType[],
  maxSizeKB: number,
  dimensions?: ImageDimensions
): string => {
  const parts: string[] = [];

  // Formatos
  if (acceptedFormats.length > 0) {
    const formats = acceptedFormats.map((f) => f.replace('.', '').toUpperCase()).join(', ');
    parts.push(`Formato ${formats}`);
  }

  // Dimensiones
  if (dimensions) {
    parts.push(`${dimensions.width}x${dimensions.height}px`);
  }

  // Tamaño
  if (maxSizeKB > 0) {
    parts.push(`Peso máximo ${maxSizeKB} KB`);
  }

  return parts.join(' - ');
};
